export const MAX_ROUTE_NAME_LENGTH = 25;
export const MAX_TRAP_NAME_LENGTH = 25;

/**
 * Minimum number of characters required for transit dashboard search
 * Used across Planning, In-Transit, and Delivered tabs
 */
export const TRANSIT_SEARCH_MIN_LENGTH = 3;

/**
 * Minimum number of characters required for Trip# search
 */
export const TRIP_NUMBER_MIN_LENGTH = 5;
